import React, { Component } from 'react';
import { CardLayout, BreadCrumb } from './containers/Layout';
import ListOrders from './orders/ListOrders';
import CardPage from '../../../commonModules/layouts/CardPage';

class Orders extends Component {
    state = { 
        breadcrumb: "",
        view: "",

        pageOfItems:[],
        currentPage: 1,
       
        view: this.props.new ? "new" : "list",
        listview: "order",

        singleShop:{},
        singleOrder:{
            order:{},
            shop:{},
        },

        breadcrumb: "",
        mdpAdmin:'',

        selectSearch:"",
        selectSearchDisplay:{
            value:"",
            label:"Tous les Magasins",
        },
    }    
    componentDidMount = async () => {
        console.log('====================================');
        console.log("MOUNTING ORDERS");
        console.log('====================================');
        await this.props.fetchOrders()
    }
        
    handleClose = () => {// close all dialog and singles
        this.setState({
            view: "list",
            breadcrumb: ""
        });
    }
    handleSingleOrder = (order, shop) => {// open single shop page
        this.setState({
            breadcrumb: `${order.nature} n°${order.id}`,
            singleOrder:{
                shop,
                order
            },
            view: "order"
        })
    }
    handleSingleShop = (shop) => {// open single shop page
        this.setState({
            breadcrumb: shop.name,
            singleShop:shop,
            view: "shop"
        })
    }
    
    onChangePage = (pageOfItems, page) => {
        this.setState({ pageOfItems, currentPage:page });
    }

    render() {
        return (
            <CardPage title="Commandes" storehouse>
                <BreadCrumb 
                    breadcrumb={ this.state.breadcrumb } 
                    title="Commandes" 
                    back={this.handleClose} 
                />
                <ListOrders
                    {...this.props}
                    {...this.state}
                    onChangePage={this.onChangePage}
                    // handleSingleShop={this.handleSingleShop}  
                    handleSingleOrder={this.handleSingleOrder}  
                />
            </CardPage>
        );
    }
}

export default Orders;